import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { WorkModelPopUp } from "../../../components/ProfileEditpopUp/WorkHistoryPopUp";
import CustomTable from "../../../blueplanitUtils/CustomTabels";
import CombinedInfoComponent from "./basicInfo";
import AddNoteBox from "./addNote";
import PersonalInformationModelPopup from "../../../components/modelpopup/PersonalInformationModelPopup";
const WorkHistory = () => {
const workHistory = useSelector((state) => state.employee.workHistory);

  // Default Columns & Labels
  const baseColumns = [
    "Department",
    "Designation",
    "Client Handled",
    "Process Handled",
    "Shift Timings",
    "From",
    "To",
  ];
 
  const baseLabels = [
    "department",
    "designation",
    workHistory?.department === "IT" ? "Technologies" : workHistory?.department === "Sales" ? "Sales Channel" : "clientHandled",
    "processHandled",
    "shiftTimings",
    "from",
    "to",
  ];
 
  // Map department → modified columns
 const { columns, labels } = useMemo(() => {
  if (!workHistory || workHistory.length === 0) {
    return { columns: baseColumns, labels: baseLabels };
  }
 
  const department = workHistory[0]?.department;
 
  let updatedColumns = [...baseColumns];
  let updatedLabels = [
    "department",
    "designation",
    "clientHandled",
    "processHandled",
    "shiftTimings",
    "from",
    "to",
  ];
 
  if (department === "IT") {
    // Remove processHandled & rename column "Client Handled" → "Technologies"
    const processIndex = updatedLabels.indexOf("processHandled");
    if (processIndex !== -1) {
      updatedColumns.splice(processIndex, 1);
      updatedLabels.splice(processIndex, 1);
    }
    const clientIndex = updatedLabels.indexOf("clientHandled");
    if (clientIndex !== -1) {
      updatedColumns[clientIndex] = "Technologies"; // only display name changes
    }
  } else if (department === "Sales") {
    // Remove processHandled
    const processIndex = updatedLabels.indexOf("processHandled");
    if (processIndex !== -1) {
      updatedColumns.splice(processIndex, 1);
      updatedLabels.splice(processIndex, 1);
    }
    const clientIndex = updatedLabels.indexOf("clientHandled");
    if (clientIndex !== -1) {
      updatedColumns[clientIndex] = "Sales Channel"; // only display name changes
    }
  } else if (department === "HR & Admin") {
    // Remove both processHandled & clientHandled
    ["processHandled", "clientHandled"].forEach((field) => {
      const idx = updatedLabels.indexOf(field);
      if (idx !== -1) {
        updatedColumns.splice(idx, 1);
        updatedLabels.splice(idx, 1);
      }
    });
  }
 
  return { columns: updatedColumns, labels: updatedLabels };
}, [workHistory]);
 
 
  const formattedWorkHistoryData = {
    from: true,
    to: true,
  };
 
  return (
    <div>
      <CombinedInfoComponent />
      <CustomTable
        title="Work History"
        dateFieldsMap={formattedWorkHistoryData}
        columns={columns}
        dataLabel={labels}
        data={workHistory}
        Id="work_history_modal_popup"
      />
      <WorkModelPopUp />
      <PersonalInformationModelPopup name={"workNote"} />
      <AddNoteBox name={"workNote"} />
    </div>
  );
};
 
export default WorkHistory;
 
 